
import React from "react";
import styles from "./Force.module.css"; 
import { FeatureTypes } from "@/types/displayData/FeatureTypes";

const ForceCardComponent: React.FC<FeatureTypes> = ({ title, description }) => {
  return (
    <div className={styles.advantageCard}>
      <h3 className={styles.advantageTitle}>{title}</h3>
      <p className={styles.advantageDescription}>{description}</p>
    </div>
  );
};

export default ForceCardComponent;
